import { Text, makeStyles } from '@rneui/themed'
import { onlineManager } from '@tanstack/react-query'
import { t } from 'app/i18l'
import { View } from 'react-native'

export function NoInternetText({ message }: { message?: string }) {
  const offline = !onlineManager.isOnline()
  const styles = useStyles()
  return (
    <View style={styles.container}>
      {offline ? (
        <View>
          <Text style={styles.text}>{t('connectionError')}</Text>
          {message ? <Text style={styles.message}>{message}</Text> : null}
        </View>
      ) : null}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    marginHorizontal: 50,
    marginTop: 10,
  },
  text: {
    textAlign: 'center',
    color: theme.colors?.primary,
    fontSize: 16,
  },
  message: {
    textAlign: 'center',
    fontSize: 12,
    marginTop: 5,
    marginBottom: 20,
  },
}))
